import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import {take, takeUntil} from 'rxjs/operators';
import { UserApi } from '../../../api';
import { FilterBuilderService } from '../../../service/filter-builder.service';
import { LoaderService } from '../../../core/loader/loader.service';
import { BarcodeDataService } from '../../../api/barcode-data.service';
import { SalonChainMappingService } from '../../../api/salon-chain-mapping.service';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import { SalonChainMappingEditComponent } from './salon-chain-mapping-edit/salon-chain-mapping-edit.component';
import { SalonChainDataMappingOption } from '../../../shared/models/salon-chain-mapping.model';
import { MappingAction, MappingMode } from '../../../shared/enum/mapping-mode.enum';
import {ExtraFilteringOptions, LoadOptions} from '../../../shared/models/shared.model';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-salon-chain-mapping',
  templateUrl: 'salon-chain-mapping.component.html'
})

export class SalonChainMappingComponent implements OnInit {
  @ViewChild('salonChainMappingDataGrid') salonChainMappingDataGrid: DxDataGridComponent;
  @ViewChild('salonChainMasterDataGrid') salonChainMasterDataGrid: DxDataGridComponent;

  public salonChainMappingGridDataSource = {};
  public salonChainMappingSelectedRowMap: any;
  public sourceSalonChainUidHeaderDataSource: any;
  public sourceSalonChainNameHeaderDataSource: any;
  public dataProviderCodeHeaderDataSource: any;
  public mappingModeNameHeaderDataSource: any;
  public createdByHeaderDataSource: any;
  public createdOnHeaderDataSource: any;
  public modifiedByHeaderDataSource: any;
  public modifiedOnHeaderDataSource: any;
  public reviewedByHeaderDataSource: any;
  public reviewedOnHeaderDataSource: any;
  public mappingSalonChainName: any;
  public mappingSalonChainWebsite: any;
  public mappingSalonChainComment: any;

  public salonChainMasterGridDataSource = {};
  public salonChainMasterSelectedRowMap: any;
  public salonChainMasterNameHeaderDataSource: any;
  public salonChainMasterWebsiteHeaderDataSource: any;
  public salonChainMasterCommentHeaderDataSource: any;
  public createdByMasterHeaderDataSource: any;
  public createdOnMasterHeaderDataSource: any;
  public modifiedByMasterHeaderDataSource: any;
  public modifiedOnMasterHeaderDataSource: any;
  public reviewedByMasterHeaderDataSource: any;
  public reviewedOnMasterHeaderDataSource: any;

  public salonChainMappingDataGridSetting: GridSetting = new GridSetting();
  public salonChainMasterDataGridSetting: GridSetting = new GridSetting();

  public currentUser: User;
  public extraFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];

  private isSalonChainMappingDataGridLoading = true;
  private isSalonChainMasterDataGridLoading = true;
  private isSalonChainMappingDataGridSettingLoading = true;
  private isSalonChainMasterDataGridSettingLoading = true;
  private _destroyed$ = new Subject();
  private mappingDataGridCurrentPage: number;

  private readonly mappingGridName: string = 'salonChainMappingDataGrid';
  private readonly masterGridName: string = 'salonChainMasterDataGrid';
  private readonly pageName: string = 'salonChainMapping';
  private currentSalonChainMappingDataGridState: GridState;
  private currentSalonChainMasterDataGridState: GridState;
  public isLoadSalonChainMappingGridDataSource: boolean;
  public isLoadSalonChainMasterGridDataSource: boolean;
  private salonChainMappingDataGridSettings: GridSettings;
  private salonChainMasterDataGridSettings: GridSettings;
  private isMoveToNextRow = false;
  private salonChainMappingSelectedRowData: any;
  private salonChainMappingSelectedRowIndex: any;

  constructor(
	private salonChainService: SalonChainMappingService,
	private userService: UserApi,
	private filterBuilder: FilterBuilderService,
	private loaderService: LoaderService,
	private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.salonChainMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridSettings(this.salonChainMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.salonChainMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.salonChainMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.salonChainMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.salonChainMappingDataGridSettings);
		}
		this.loadSalonChainMappingDataGridState();
		});

	this.salonChainMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.salonChainMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.salonChainMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.salonChainMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.salonChainMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.salonChainMasterDataGridSettings);
		}
		this.loadSalonChainMasterDataGridState();
		});

	this.loadSalonChainMappingDataGridHeaderFilters();
	this.loadSalonChainMasterDataGridHeaderFilters();
  }

  public selectionMasterDataChangedHandler() {
	if (this.salonChainMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.salonChainMasterSelectedRowMap =
		this.salonChainMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  private loadSalonChainMappingDataGridState() {
	const salonChainMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(salonChainMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentSalonChainMappingDataGridState = state;
		} else {
			this.currentSalonChainMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadSalonChainMappingGridDataSource();
		});
  }

  public loadMappingState = () => {
	return this.currentSalonChainMappingDataGridState.State ? JSON.parse(this.currentSalonChainMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.salonChainMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.salonChainMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.salonChainMappingDataGridSetting);
		} else {
		gridSetting = this.salonChainMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentSalonChainMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentSalonChainMappingDataGridState);
		}
	}
  }

  private loadSalonChainMasterDataGridState() {
	const salonChainMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(salonChainMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentSalonChainMasterDataGridState = state;
		} else {
			this.currentSalonChainMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadSalonChainMasterGridDataSource();
		});
  }

  public loadMasterState = () => {
	return this.currentSalonChainMasterDataGridState.State ? JSON.parse(this.currentSalonChainMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.salonChainMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.salonChainMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.salonChainMasterDataGridSetting);
		} else {
		gridSetting = this.salonChainMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentSalonChainMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentSalonChainMasterDataGridState);
		}
	}
  }

  public onReady(e: any) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (this.salonChainMappingSelectedRowMap) {
		const currentDataItems = this.salonChainMappingDataGrid.instance.getDataSource().items();
		const isSelectedRowExists = currentDataItems.find(item =>
		item.SalonChainMappingId ===
		this.salonChainMappingSelectedRowMap.SalonChainMappingId
		);
		if (currentDataItems.length === 0 || !isSelectedRowExists) {
		this.salonChainMappingSelectedRowMap = {};
		}
		if (!isSelectedRowExists) {
		grid.selectRowsByIndexes([0]);
		}
	}
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	} else {
		if (this.isMoveToNextRow && this.isNextRowAvailable) {
		this.moveToNextRow();
		this.isMoveToNextRow = false;
		} else {
		this.stayInRow();
		}
	}
  }

  private stayInRow() {
	this.setSalonChainMappingSelectedRowIndex();
	this.salonChainMappingDataGrid.instance.selectRowsByIndexes([this.salonChainMappingSelectedRowIndex]);
  }

  private get isNextRowAvailable() {
	const productMappingRowData = this.salonChainMappingDataGrid.instance.getRowElement(this.salonChainMappingSelectedRowIndex + 1);
	if (productMappingRowData) {
		return true;
	}

	return false;
  }

  private moveToNextRow() {
	this.setSalonChainMappingSelectedRowIndex();
	this.salonChainMappingDataGrid.instance.selectRowsByIndexes([this.salonChainMappingSelectedRowIndex + 1]);
  }

  private setSalonChainMappingSelectedRowIndex() {
	const selectedRowKey = this.salonChainMappingSelectedRowData.PostalCodeMappingId;
	const postalCodeMappingSelectedRowIndex = this.salonChainMappingDataGrid.instance.getRowIndexByKey(selectedRowKey);
	this.salonChainMappingSelectedRowIndex = postalCodeMappingSelectedRowIndex >= 0 ?
		postalCodeMappingSelectedRowIndex : this.salonChainMappingSelectedRowIndex;
  }

  public onReadyMasterGrid(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  public salonChainMasterDataGridContextMenu(e: any) {
	e.event.stopPropagation();
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshMasterGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.salonChainMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.salonChainMasterDataGridSetting.autosave = !this.salonChainMasterDataGridSetting.autosave;
				this.salonChainMasterDataGridSettings.Settings = JSON.stringify(this.salonChainMasterDataGridSetting);
				this.updateGridSettings(this.salonChainMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  private refreshMappingGrid() {
	this.salonChainMappingDataGrid.instance.refresh();
  }

  public editSalonChainMasterData(data: any) {
	const modalRef = this.modalService.open(
		SalonChainMappingEditComponent,
		{size: 'lg', backdrop: true}
	);
	modalRef.componentInstance.data = data;
	modalRef.componentInstance.currentUser = this.currentUser;
	modalRef.result.then(result => {
		// onclose
		this.refreshMasterGrid();
	}, (reason) => {
		// ondismiss
		this.refreshMasterGrid();
	});
  }

  public createSalonChain() {
	const modalRef = this.modalService.open(
		SalonChainMappingEditComponent,
		{size: 'lg', backdrop: true}
	);
	modalRef.componentInstance.data = undefined;
	modalRef.componentInstance.currentUser = this.currentUser;
	modalRef.result.then(result => {
		// onclose
		this.refreshMasterGrid();
	}, (reason) => {
		// ondismiss
		this.refreshMasterGrid();
	});
  }

  public selectionMappingDataChangedHandler() {
	if (this.salonChainMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.salonChainMappingSelectedRowMap =
		this.salonChainMappingDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  public salonChainMappingDataGridContextMenu(e: any) {
	e.event.stopPropagation();
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshMappingGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.salonChainMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.salonChainMappingDataGridSetting.autosave = !this.salonChainMappingDataGridSetting.autosave;
				this.salonChainMappingDataGridSettings.Settings = JSON.stringify(this.salonChainMappingDataGridSetting);
				this.updateGridSettings(this.salonChainMappingDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  private refreshMasterGrid() {
	this.salonChainMasterDataGrid.instance.refresh();
  }

  public omit(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Omit;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public save(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Save;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public accept(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Accept;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public review(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Review;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public deactivate(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Deactivate;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public reactivate(salonChainMappingId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.SalonChainMappingId = salonChainMappingId;
	mappingData.ActionType = MappingAction.Reactivate;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  public map(salonChainId: any) {
	const mappingData: SalonChainDataMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Map;
	mappingData.SalonChainId = salonChainId;
	mappingData.SalonChainMappingId = this.salonChainMappingSelectedRowMap.SalonChainMappingId;
	this.loaderService.show();
	this.salonChainService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshMappingGrid();
		});
  }

  private loadSalonChainMappingDataGridHeaderFilters() {
	this.sourceSalonChainUidHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceSalonChainUid';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.sourceSalonChainNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceSalonChainName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.dataProviderCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderCode';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.createdByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.modifiedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.reviewedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.mappingSalonChainName = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SalonChainName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.mappingSalonChainWebsite = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SalonChainWebsite';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.mappingSalonChainComment = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SalonChainComment';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMapping(loadOptions);
		}
	});

	this.mappingModeNameHeaderDataSource = [
		{
		text: 'New',
		value: 0
		},
		{
		text: 'Map',
		value: 1
		},
		{
		text: 'Save',
		value: 2
		},
		{
		text: 'Omit',
		value: 2
		}
	];
  }

  private getHeaderFiltersSalonChainMapping(loadingOption) {
	return this.salonChainService.getHeaderFiltersSalonChainMappingGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  private loadSalonChainMasterDataGridHeaderFilters() {
	this.salonChainMasterNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Name';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.salonChainMasterWebsiteHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Website';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.salonChainMasterCommentHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Comment';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.createdByMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.createdOnMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.modifiedByMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.modifiedOnMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.reviewedByMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});

	this.reviewedOnMasterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.ValueColumn = '';

		return this.getHeaderFiltersSalonChainMaster(loadOptions);
		}
	});
  }

  extraFilteringOptionsChange(columnName, event) {
	if (event) {
		if (columnName === 'Active') {
		const option = this.extraFilteringOptions.find(item => item.column === columnName);
		option.value = !event.value;
		} else {
		const option = this.extraFilteringOptions.find(item => item.column === columnName);
		option.value = event.value;
		}
		this.salonChainMappingDataGrid.instance.deselectAll();
		this.refreshGrid();
	}
  }

  private getHeaderFiltersSalonChainMaster(loadingOption) {
	return this.salonChainService.getHeaderFiltersSalonChainMasterGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  refreshGrid() {
	this.mappingDataGridCurrentPage = this.salonChainMappingDataGrid.instance.pageIndex();
	this.salonChainMappingDataGrid.instance.refresh();
  }

  private formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  private loaderHandler() {
	if (
		!this.isSalonChainMappingDataGridLoading &&
		!this.isSalonChainMasterDataGridLoading &&
		!this.isSalonChainMappingDataGridSettingLoading &&
		!this.isSalonChainMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  private loadSalonChainMappingGridDataSource() {
	this.isSalonChainMappingDataGridSettingLoading = false;
	this.salonChainMappingGridDataSource = new CustomStore({
		key: 'SalonChainMappingId',
		load: (loadOptions: any) => {
		this.isSalonChainMappingDataGridLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;

		return this.salonChainService.getSalonChainMappingGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isSalonChainMappingDataGridLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isSalonChainMappingDataGridLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadSalonChainMappingGridDataSource = true;
  }

  private loadSalonChainMasterGridDataSource() {
	this.isSalonChainMasterDataGridSettingLoading = false;
	this.salonChainMasterGridDataSource = new CustomStore({
		key: 'SalonChainId',
		load: (loadOptions: any) => {
		this.isSalonChainMasterDataGridLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;

		return this.salonChainService.getSalonChainMasterGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isSalonChainMasterDataGridLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isSalonChainMasterDataGridLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadSalonChainMasterGridDataSource = true;
  }
}
